import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  footer: {
    padding: '20px 15px',
    textAlign: 'center',
    marginTop: 'auto',
    zIndex: 1001,

    '& $feedbackText': {
      color: 'var(--text-secondary-color)',
      fontSize: 14,
      fontStyle: 'italic',
      marginBottom: 8,
      fontWeight: 400,
      '& a': {
        fontSize: 'inherit',
      },
    },

    '& $link': {
      color: '#46c0ec',
      fontWeight: 500,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline ',
      },
    },
  },
  footerLinks: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    margin: '0 auto 20px',
    [theme.breakpoints.down(430)]: {
      gap: 0,
    },
  },
  footerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    justifyContent: 'center',
    flexWrap: 'wrap',
    [theme.breakpoints.down(430)]: {
      flexDirection: 'column',
    },
  },
  footerLink: {
    textDecoration: 'none !important',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      opacity: 0.8,
    },
    '& svg': {
      height: 24,
      width: 'auto',
      '& path, & .cls-1': {
        fill: 'var(--text-color, #222222) !important',
      },
    },
    [theme.breakpoints.down(430)]: {
      padding: 5,
    },
  },
  mowsub: {
    '& svg': {
      height: 26,
      paddingTop: 5,
    },
  },
  mowboost: {
    '& svg': {
      height: 28,
      paddingTop: 2,
    },
  },
  youtube: {
    '& svg': {
      height: 29,
      paddingTop: 5,
    },
  },
  dot: {
    color: '#f66000',
    fontSize: 35,
    lineHeight: 0,
    [theme.breakpoints.down(430)]: {
      display: 'none',
    },
  },

  copyright: {
    color: 'var(--text-color)',
    fontSize: 16,
    fontWeight: '500 ',
  },
  link: {},
  feedbackText: {},
}));
